import {HttpClient, HttpErrorResponse, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {BACKEND_METHOD_CONSTANT, BACKEND_METHOD_TYPES, URL_CONSTANT} from './url-constant';

import {BaseAPI} from './baseAPI';
import {TimezoneModel} from '../models/timezone.model';
import {AuthService} from './auth.service';
import {BaseModel} from '../models/base.model';
import {map} from 'rxjs/operators';

@Injectable()
export class MasterService extends BaseAPI {
  constructor(public http: HttpClient, public authService: AuthService) {
    super(http, authService);
  }

  public getTimezones(): Observable<TimezoneModel[]> {
    return this.http.get('assets/timezones.json').pipe(map((timezones: TimezoneModel[]) => {
      return timezones ? timezones : undefined;
    })).catch(this.handleError);
  }

  getObjects(objectType: string): Observable<BaseModel[]> {
    const httpParams = this.getBaseHttpParams();

    // if (siteId != null) {
    //   httpParams = httpParams.set(BACKEND_KEYS.siteId, String(siteId))
    // }
    // if (filterId != null) {
    //   httpParams = httpParams.set(BACKEND_KEYS.filterId, String(filterId));
    // }

    const url = objectType + BACKEND_METHOD_TYPES.list;

    return this.get(url, httpParams).pipe(map((objects: BaseModel[]) => {
      return objects ? objects : undefined;
    }))
      .catch(this.handleError);
  }

  getObjectFromId(objectId: number, objects: BaseModel[]): BaseModel {
    for (const object of objects) {
      if (objectId === object.id) {
        return object;
      }
    }
    return null;
  }

}
